"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const mutation = (0, client_1.gql) `
  mutation verifyUserEmail($emailVerificationToken: String!) {
    verifyUserEmail(emailVerificationToken: $emailVerificationToken) {
      emailVerified
    }
  }
`;
exports.default = mutation;
//# sourceMappingURL=verifyUserEmail.mutation.js.map